<template>
    <div>
        <app-finalizacao-associar-entregas
            :finalizacoesServicos="obterFinalizacoesServicos()"
            @obterFinalizacaoAtualizada="obterFinalizacaoAtualizada()"
            :finalizacao="finalizacao"
        ></app-finalizacao-associar-entregas>
    </div>
</template>

<script>
import FinalizacoesServicos from './FinalizacoesServicos'
import FinalizacaoAssociarEntregas from '@/app/credenciados/componentes/finalizacoes/FinalizacaoAssociarEntregas'

export default {
	props: {
		finalizacao: {
			type: Object
		}
	},

	data() {
		return {}
	},

	methods: {
		obterFinalizacoesServicos() {
			return FinalizacoesServicos
		},

		obterFinalizacaoAtualizada() {
			this.$emit('obterFinalizacaoAtualizada')
		}
	},

	components: {
		AppFinalizacaoAssociarEntregas: FinalizacaoAssociarEntregas
	}
}
</script>
